import React, { useEffect, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../store/appContext";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import { useForm, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import Banner from "../../components/banner/banner";
import WebLoader from "../../components/webLoader/WebLoader";
import "./betrugspravention.scss";
import translate from "../../services/translation.json";
import { Fade,Slide } from "react-awesome-reveal";

let inputFontColor = "white";

const Betrugspravention = () => {
  const {
    state: { baseUrl, betrugspravention, lang, lightMode },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(betrugspravention).length > 0;
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    const payload = {
      ...data,
      language: lang,
    };
    // Send data to the server
    axios
      .post(`${baseUrl}save-betrugsprävention`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        // Close the contact form
        alert("Form submitted successfully");
      })
      .catch((error) => {
        console.error("Error sending data:", error);
        // Handle error response
        alert("Error submitting form");
      });
  };
  useEffect(() => {
    axios.get(`${baseUrl}betrugsprävention`).then((response) => {
      dispatchAction("setBetrugspraventionData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll(
      '.page-container span[style="color: white;"]'
    );
    inputFontColor = lightMode ? "#131A3B" : "white";
    // Add a class to each of these spans
    spans.forEach((span) => {
      span.classList.add("white-text");
    });
    // Find all span elements that have style="color: rgb(212, 185, 123);"
    const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [betrugspravention, lightMode]);

  const renderForm = () => {
    return (
      <div className="betrugspravention-form">
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.name}</p>
            <Controller
              name="name"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.name,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665", borderColor: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.name}
                  variant="filled"
                  error={!!errors.name}
                  helperText={errors.name ? errors.name.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.address}</p>
            <Controller
              name="address"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.address,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.address}
                  variant="filled"
                  error={!!errors.address}
                  helperText={errors.address ? errors.address.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.plz}</p>
            <Controller
              name="plz"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.plz,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.address}
                  variant="filled"
                  error={!!errors.plz}
                  helperText={errors.plz ? errors.plz.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.ort}</p>
            <Controller
              name="ort"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.ort,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.ort}
                  variant="filled"
                  error={!!errors.ort}
                  helperText={errors.ort ? errors.ort.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.email}</p>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.email,
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.email}
                  variant="filled"
                  type="email"
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.person}</p>
            <Controller
              name="person"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.person,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.address}
                  variant="filled"
                  error={!!errors.person}
                  helperText={errors.person ? errors.person.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.website}</p>
            <Controller
              name="website"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.website,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.website}
                  variant="filled"
                  error={!!errors.website}
                  helperText={errors.website ? errors.website.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>Angebot des Finanzdienstleisters</p>
            <Controller
              name="angebot"
              control={control}
              defaultValue=""
              rules={{
                required: "Angebot des Finanzdienstleisters is required",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label="Enter Angebot des Finanzdienstleisters"
                  variant="filled"
                  error={!!errors.angebot}
                  helperText={errors.angebot ? errors.angebot.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.vorfall}</p>
            <Controller
              name="vorfall"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].betrugspravention_form.rules.vorfall,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.vorfall}
                  variant="filled"
                  error={!!errors.vorfall}
                  helperText={errors.vorfall ? errors.vorfall.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <p>{translate[lang].betrugspravention_form.rules.anliegens}</p>
            <Controller
              name="anliegens"
              control={control}
              defaultValue=""
              rules={{
                required:
                  translate[lang].betrugspravention_form.rules.anliegens,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor }, // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].betrugspravention_form.label.anliegens}
                  variant="filled"
                  error={!!errors.anliegens}
                  helperText={errors.anliegens ? errors.anliegens.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>

          <button type="submit" className="submit-btn">
            {translate[lang].betrugspravention_form.submit}
          </button>
        </form>
      </div>
    );
  };

  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="betrugspravention-page page">
        {betrugspravention && isDataReady && (
          <React.Fragment>
            <Banner
              mediaUrl={betrugspravention.banners[0].path}
              title={betrugspravention.banners[0]["title_" + lang]}
            />
            <div className="page-container" id="page-container">
              <Fade duration={1000} triggerOnce={true} fraction={0.2}>
              <div className="details">
                <h2
                  className="title"
                  dangerouslySetInnerHTML={{
                    __html:
                      betrugspravention.betrugspravention[0]["title_" + lang],
                  }}
                />
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html:
                      betrugspravention.betrugspravention[0][
                        "description_" + lang
                      ],
                  }}
                />
              </div>
              </Fade>
              <Slide duration={1000} triggerOnce={true} fraction={0.1}>
              {renderForm()}
              </Slide>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default Betrugspravention;
